import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLoading } from "../../../context/LoadingContext";
import { Card, Container, Button, Form, Row, Col } from "react-bootstrap";
import InputSearch from "../../../components/InputSearhComponent";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import TableForm2s from "../../../components/TableFormScrb";
import ConfirmModal from "../../../components/ConfirmModal";
import SearchFilter from "../../../components/SearchFilter";
import { useNavigate, useLocation } from "react-router-dom";
import TableForm from "../../../components/TableForm";
import TechExpenseService from "../../../services/techexpenses.service";
import { getQueryString } from "../../../utils/Query";
import { useAlert } from "../../../context/AlertContext";
import { addEditServiceRequest, getServiceRequest } from "../../../commons/ServiceRequest";
import { toFormatISO } from "../../../utils/Time";
import { formatDate } from "../../../commons/FormatValue";

export default function AddExpense() {
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();

  useEffect(() => {
    fetchSeqNo()
  }, []);

  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [SeqNo, setSeqNo] = useState([]);
  const [allSeqNo, setAllSeqNo] = useState();
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [querySearch, setQuerySearch] = useState();

  const searchInput = [
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 3,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: SeqNo
      }),
      noneAsync: true,
      // queryService: (query, value) => {
      //   const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
      //   getServiceRequest({
      //     showAlert,
      //     setLoading: () => { },
      //     serviceRequest: TechExpenseService.getSeqNo(q),
      //     callback: (array) => {
      //       const newArray = array.data?.map(arr => ({
      //         ...arr,
      //         seq_no: arr.seq_no
      //       }))
      //       setSeqNo(newArray)
      //     }
      //   });
      // }
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      value: tableData[0]?.job_type_name,
      type: "text"
    },
    {
      name: "no",
      label: "ครั้งที่/งานย่อย",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      value: tableData[0]?.no,
      type: "text"
    },
    {
      name: "date",
      label: "วันที่บันทึก",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 3,
      disabled: true,
      value: tableData[0]?.cus_code,
      type: "text"
    },
    {
      name: "num_branch",
      label: "เลขทีสาขา",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      value: tableData[0]?.num_branch,
      type: "text"
    },
    {
      name: "cus_name",
      label: "ชื่อสาขา",
      classNames: { label: "mb-3" },
      size: 5,
      disabled: true,
      value: tableData[0]?.cus_name,
      type: "text"
    },
  ];

  const columns = [
    {
      name: "expenses_desc",
      label: "รายละเอียดอุปกรณ์/อะไหล่",
      width: "160px"
    },
    {
      name: "expenses_qty",
      label: "จำนวน",
      width: "80px"
    },
    {
      name: "expenses_unit",
      label: "หน่วย",
      width: "80px",
    },
    {
      name: "expenses_price",
      label: "ราคา",
      width: "80px"
    },
    {
      name: "expenses_total_price",
      label: "จำนวนเงิน",
      readOnly: true,

    },
    {
      name: "expenses_price_unit",
      label: "สกุลเงิน",
    },
    {
      name: "remark",
      label: "หมายเหตุ",
    },
  ];

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      try {
        const all = dataCallback.map(p => {
          const obj = (tableData.find(a => a.tech_expenses_id == p.tech_expenses_id))
          if (obj) return { ...obj }
          return {
            ...p,
            delete: true,
          }
        })

        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: TechExpenseService.createTechExpense(
            { Array: all.concat(tableData.filter(a => !a.tech_expenses_id)) }
          ),
          navigated: (navi) =>
            navi &&
            navigate("/service_work/expenses")
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  function getDataTable(search) {
    if (!search?.seq_no) {
      setTableData([])
      return
    }
    setLoading(true)
    const page = search?.page

    const q = {
      // ...querySearch,
      page: page, limit: 100, ...search,
      start: toFormatISO(search.start),
    }
    setQuerySearch(q)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechExpenseService.getAllTechExpense(getQueryString(q)),
      callback: (res) => {
        initData(
          res.data.length ? res.data : null
        )
      }
    });
  }
  const rowData = {
    date: new Date(),
    detail: "",
    quantity: "",
    unit: "",
    price: "",
    total: "",
    currency: "",
    remark: "",

    delete: true //
  }
  function initData(data) {
    const newArray = data?.map(el => {
      return {
        // Id: el.id,
        "tech_work_id": el.tech_work_id,
        "tech_plan_id": el.tech_plan_id,
        "tech_expenses_id": el.id,
        expenses_date: formatDate(el.expenses_date),
        expenses_desc: el.expenses_desc,
        expenses_qty: el.expenses_qty,
        expenses_unit: el.expenses_unit,
        expenses_price: el.expenses_price,
        expenses_total_price: el.expenses_total_price,
        expenses_price_unit: el.expenses_price_unit,
        remark: el.remark,
        // job_actual_date: el.TechnicianPlan.job_actual_date,
        // seq_no: el.TechnicianPlan.seq_no,
        // job_type_name: state.JobType.find(j => j.Id == el.TechnicianPlan.job_type_id)?.Job_Type_Name,

      }
    })
    setTableData(newArray || [rowData])
  }

  function fetchSeqNo(search) {
    if (!search) {
      if (!allSeqNo) {
        getSeqNoList({}, 'all')
      } else {
        setSeqNo(allSeqNo)
      }
      return
    }

    getSeqNoList(search)
  }
  function getSeqNoList(search, isAll) {
    const q = getQueryString(search)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechExpenseService.getSeqNo(q),
      callback: (res) => {
        const data = res.data.map(d => {
          return {
            seq_no: d.seq_no,
            tech_plan_id: d.id
          }
        })
        if (isAll) {
          setAllSeqNo(data)
        }
        setSeqNo(data)
      }
    });
  }

  return (
    <>
      <Helmet>
        <title>เพิ่มค่าใช้จ่ายระหว่างทำงาน</title>
        <meta name="description" content="Expenses During Work Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Title className="mb-4 mt-2 fs-2 text-center">
            เพิ่มค่าใช้จ่ายระหว่างทำงาน
          </Card.Title>

          {/* <SearchFilter
            data={searchInput}
            inputField={searchInput}
            searchCallback={search => search ? getDataTable(search) : setTableData([])}
          /> */}
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchByField={{ name: 'seq_no', queryService: search => fetchSeqNo(search) }}
            searchCallback={search => { search ? getDataTable(search) : setTableData([]); }}
            fieldClassName={{ actionButton: "", inputRow: "justify-content-center" }}
          />
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดค่าใช้จ่ายระหว่างทำงาน
            </Card.Title>
          </Card.Header>

          <Form noValidate className="pb-4" >
            <TableForm
              data={tableData}
              columns={columns}
              // pending={loading}
              editForm={false}
              onChangeCallback={(newData) => {
                const prev = dataModal || [...tableData]
                const array = newData.map(item => ({
                  "tech_work_id": item.tech_work_id || null,
                  "tech_plan_id": SeqNo.find(el => el.seq_no == querySearch.seq_no)?.tech_plan_id || item.tech_plan_id,
                  "tech_expenses_id": item.tech_expenses_id,
                  "expenses_date": new Date(),
                  "expenses_desc": item.expenses_desc,
                  "expenses_qty": item.expenses_qty,
                  "expenses_unit": item.expenses_unit,
                  "expenses_price": item.expenses_price,
                  "expenses_total_price": item.expenses_price * item.expenses_qty,
                  "expenses_price_unit": item.expenses_price_unit,
                  "remark": item.remark || "",
                }))
                setTableData(array)

                setDataModal(prev)
              }}
            />
          </Form>
          <Row className="justify-content-end mt-3">
            <Col className="col-auto">
              <Button
                type="submit"
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
                onClick={() => setShowModal(!showModal)}
                disabled={!dataModal}
              >
                บันทึกข้อมูล
              </Button>
              <ConfirmModal
                show={showModal}
                data={dataModal}
                content={"save"}
                onSubmitCallback={handleSubmit}
              />
              <Button
                variant="outline-secondary"
                className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                onClick={() =>
                  navigate("/service_work/expenses")
                }
              >
                ย้อนกลับ
              </Button>
            </Col>
          </Row>
        </Card>

      </Container>
    </>
  );
}
